module.exports = __webpack_public_path__ + "_assets/img/Frame1197.8853a60c.svg";